module.exports = __webpack_public_path__ + "static/img/car_done.3898d0b1.png";